import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { removeSubscriptionIdFromText } from './removeSubscriptionIdFromText';
import { getVNextFeatures } from '../vNext/helpers/routing/getVNextFeatures';

export const useIdentifyIterate = () => {
    const { pathname = '' } = useLocation();
    const { delivery } = getVNextFeatures();

    useEffect(() => {
        if (Iterate) {
            Iterate('identify', null, {
                domain: CONFIG.myPage?.frontPageUri || '',
                currentUrl: removeSubscriptionIdFromText(window.location.pathname),
                rollout_delivery: delivery,
            });
        }
    }, [pathname, delivery]);
};
